const transition = {
  fast: '200ms linear',
  normal: '350ms linear',
  slow: '500ms linear',
};

export default transition;
